import { SingleOrdersCache } from './single-orders-cache';
import { TimeStampsCache } from './time-stamps-cache';
import { OrderLineType } from '../../order/models/order-line-type';
import { BookingOrderService } from '../services/booking-order.service';

export class SingleBookingCache {
  private _ordersCache: SingleOrdersCache;
  private _timeStampsCache: TimeStampsCache;
  private _invalidReason: string;

  constructor(
    private bookingOrderService: BookingOrderService
  ) {
    this._ordersCache = new SingleOrdersCache(bookingOrderService);
    this._timeStampsCache = new TimeStampsCache(bookingOrderService);
  }

  get ordersCache(): SingleOrdersCache {
    return this._ordersCache;
  }

  get timeStampsCache(): TimeStampsCache {
    return this._timeStampsCache;
  }

  reset() {
    this.ordersCache.reset();
    this.timeStampsCache.reset();
    this._invalidReason = null;
  }

  updateInvalidReason(invalidReasons: Array<string> = null) {
    if (!invalidReasons) {
      invalidReasons = new Array<string>();
    }

    if (this.bookingOrderService.isPartnerHaveMaxOrderCount) {
        invalidReasons.push('You have a maximum count of the Webshop orders!');
        this._invalidReason = invalidReasons.join(', ');
        return;
    }

    const order = this.bookingOrderService.order;
    const products = order.orderLines.filter(x => x.orderLineType === OrderLineType.SingleProduct && x.quantity > 0);
    const pickupPointId = this.bookingOrderService.selectedPickupPointId;
    const pickupPoints = this.bookingOrderService.areaAreaItemPack && this.bookingOrderService.areaAreaItemPack.pickupPoints ? this.bookingOrderService.areaAreaItemPack.pickupPoints : null;
    const pickupPointExist = pickupPoints && pickupPoints.length !== 0;

    const selectedDate = this.bookingOrderService.selectedBookingDate;
    let isHaveCurrentPickUpPoint = true;
    for (const productLine of products) {
      if (selectedDate && productLine.bookingDate && productLine.bookingDate.getTime() === selectedDate.getTime()) {
        if (!productLine.pickupPointId) {
          isHaveCurrentPickUpPoint = false;
        }
        break;
      }
    }

    if (!products.length && (!pickupPointExist || (pickupPointExist && pickupPointId))) {
      invalidReasons.push('Please select a product!');
    }

    if (pickupPointExist) {
      if (!products.length && !pickupPointId) {
        invalidReasons.push('Please select a product and transfer point!');
      }
      if (products.length && !pickupPointId && !isHaveCurrentPickUpPoint) {
        invalidReasons.push('Please select a transfer point!');
      }
    }

    this._invalidReason = invalidReasons.join(', ');
  }

  get invalidReason(): string {
    return this._invalidReason;
  }
}
